
<div class="flow-breadcrumb-container">
	<template v-for="(crumb, index) in crumbs">
		<div
			:key="'crumb_' + crumb.label"
			v-tooltip="{
				content: crumb.label,
				placement: 'bottom',
				classes: ['black']
			}"
			class="flow-b-crumb"
			:class="{ 'crumb-avatar': !crumb.icon && !crumb.emoji }"
			:state="crumb.state ? crumb.state : 'default'"
			:style="crumbStyle"
			:tabindex="crumb.tabindex ? crumb.tabindex : 0"
			:textOnly="textOnly"
			:data-qa-crumb-id="crumb.qaId"
			@click="handleClick(crumb)"
		>
			<template v-if="!textOnly">
				<Icon
					v-if="crumb.icon"
					:name="crumb.icon.name"
					:type="crumb.icon.type ? crumb.icon.type : 'filled'"
					:state="crumb.icon.state ? crumb.icon.state : 'default'"
					size="20px"
					:effects="false"
				/>
				<template v-if="crumb.emoji">
					<span class="flow-b-crumb-emoji" v-html="crumb.emoji" />
				</template>
				<Avatar
					v-if="!crumb.icon && !crumb.emoji"
					:ref="'crumb-avatar-' + index"
					:label="crumb.shortLabel ? crumb.shortLabel : crumb.label"
					:size="20"
					shape="square"
				/>
			</template>
			<Typography type="p2" color="dark" overflow="ellipsis" class="flow-crumb-label">
				{{ crumb.label }}
			</Typography>
		</div>
	</template>
	<p
		v-if="!textOnly"
		v-tooltip="{
			content: lastcrumblabel,
			placement: 'bottom',
			classes: ['black']
		}"
		class="fc-normal paragraph-2 line-h-16 text-ellipsis last-crumb-label flow-crumb-label"
	>
		{{ lastcrumblabel }}
	</p>
</div>
